<template>
	<div class="module_course">

		<course-header-s-r ref="courseHeader" :course-id="course.uuid" class="header_entity_result"></course-header-s-r>

		<div class="row page-content content_entity_result">

			<div class="col-6 equal-column pl-0 pt-0 toc_panel">

				<div class="subhead_col_left header">
					<div class="header-view"></div>
					<span v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></span>
          <span v-if="entity.fileType === 'video'" class="icon icon-video"></span>
          <span v-if="entity.fileType === 'scorm'" class="icon icon-scorm"></span>
					<span v-if="entity.fileType === 'pdf'" class="icon icon-file-pdf"></span>
					<span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="icon icon-file-word"></span>
					<span v-if="entity.fileType === 'xlsx'" class="icon icon-file-excel"></span>
					<span v-if="entity.fileType === 'html'" class="icon icon-pageURL"></span>
					<span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="icon icon-image"></span>
				  	<h3 class="entity-title float-left">{{entity.title}}</h3>
				</div>

				<div class="entity-content-section float-left w-100">

					<div v-html="entity.description" class="description float-left w-100 mb-3"></div>
					<template v-if="isEntityActivityLoaded">
            <!-- REMOVE SHOWING TIME TAKEN
    					<div  v-if="entity.type === 'ASSESSMENT'" class="time_taken">
                          Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.assessmentTimeTaken)}}</strong>
                        </div>
                        <div  v-else class="time_taken">
                          Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.resourceTimeTaken)}}</strong>
                        </div>
                      -->
                      <div  v-if="entity.type !== 'ASSESSMENT'" class="time_taken ace_sec_txt">
                        Great! You completed {{entity.title}}. Keep going!
                      </div>
                    </template>

					<div v-if="entity.objectType === 'LearningContent'" class="float-left w-100">
						<div v-if="entity.type === 'ASSESSMENT'" class="mt-2 entity_result">
						  <template v-if="isEntityDetailLoaded">
							<assessment-detail-s-r :uuid ="entity.uuid" :course-id="course.uuid"></assessment-detail-s-r>
						  </template>
						</div>
						<div v-else>
						</div>
					</div>

					<div v-else>
						<!--
					  	<p>Progress</p>
					  	<hr>
					  	<b-card class="course-description-card"></b-card>
					  	<p>Competencies</p>
					  	<hr>
					  	<b-card class="course-description-card"></b-card>
					  	-->
					</div>

				</div>
			</div>

			<div class="col-6 equal-column ml-0 px-0">
				<div v-if="isNextEntityDetailLoaded">

					<div class="entity-nav pl-3" v-if="nextEntity.title !== 'COURSE_FINISHED' && nextEntity.title !== 'KC_SUBMITTED'">
						<span v-if="nextEntity.fileType === 'assessment'" class="icon icon-assessment"></span>
			            <span v-if="nextEntity.fileType === 'video'" class="icon icon-video"></span>
			            <span v-if="nextEntity.fileType === 'pdf'" class="icon icon-file-pdf"></span>
			            <span v-if="nextEntity.fileType === 'doc' || entity.fileType === 'docx'" class="icon icon-file-word"></span>
			            <span v-if="nextEntity.fileType === 'xlsx'" class="icon icon-file-excel"></span>
			            <span v-if="nextEntity.fileType === 'html'" class="icon icon-pageURL"></span>
			            <span v-if="nextEntity.fileType === 'externalurl'" class="icon icon-pageURL"></span>
			            <span v-if="nextEntity.fileType === 'other'" class="icon icon-pageURL"></span>
			            <span v-if="nextEntity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="icon icon-image "></span>
					    <h3 class="entity-title float-left">{{nextEntity.title}}</h3>
					</div>


					<div v-if="nextEntity.title !== 'COURSE_FINISHED' && nextEntity.title !== 'KC_SUBMITTED'">
						<div class="entity-content-section">
							<!--<div v-html="nextEntity.description" class="description mb-3"></div>-->
							<div v-if="nextEntity.objectType === 'LearningContent'" class="float-left w-100">
                                <template v-if="((course.courseType === 'RICH_HTML_SUPPORT') && (nextEntity.type === 'RICH_HTML'))">
                                    <rich-html-launch-assessment :resource-id="nextEntity.uuid" :html="nextEntity.htmlBody" :course-id="course.uuid" @afterRender="afterRenderRichHtml" :container-class="'rich-html-container'"></rich-html-launch-assessment>
                                </template>
                                <template v-else>
    							  	<div v-if="nextEntity.type === 'ASSESSMENT'" class="mt-3">
    									<assessment-detail-s-r :uuid ="nextEntity.uuid" :course-id="course.uuid" :doNotShowOutcome="true"></assessment-detail-s-r>
    							  	</div>
    							  	<div v-else>
    									<b-button :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: nextEntity.objectType, entityUuid: nextEntity.uuid } }" variant="primary" size="lg" class="btn_lg" aria-label="Start Learning">Start Learning</b-button>
    							  	</div>
							  	</template>
							</div>

						</div>
					</div>


					<div v-if="nextEntity.title === 'COURSE_FINISHED'">
						<div class="col-12 navigate-to-dashboardPage">

							<div class="success-msg">
								You’ve finished the course <i>{{ course.title }}</i>
							</div>

							<!--
							<div class="result-wrapper">
								<div class="result-row row">
									<div class="result-label"> Final Score - </div>
									<div class="result-value" id="prog_val"></div>
								</div>

								<div class="result-row row">
									<div class="result-label"> Time Taken - </div>
									<div class="result-value">  4 Weeks </div>
								</div>

								<div class="result-row row">
									<div class="result-label"> Competencies Completed - </div>
									<div class="result-value">  16 of 16 </div>
								</div>
							</div>
							-->

							<div class="more-details" style="margin-top: 60px;">
								<p>For more details go to the course dashboard.</p>
							</div>
							<div class="w-100 d-flex justify-content-center">
								<b-button :to="{ name: 'courseDashboard', params: { uuid: course.uuid} }" variant="primary" size="lg" class="btn_lg mb-4 mt-2" aria-label="Go to Dashboard">Go to Dashboard</b-button>
							</div>

						</div>
					</div>



					<div v-if="nextEntity.title === 'KC_SUBMITTED'">
						<div class="col-12 navigate-to-dashboardPage">

							<div class="success-msg">
								You’ve successfully submitted the quest. Please wait for next action from your coach. <br/><br/><br/><b>
                Once the next quest is available you will be notified via email.</b>
							</div>

						</div>
					</div>




				</div>
			</div>

		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeaderSR from './CourseHeaderSR'
import TOCSR from './TOCSR'
import AssessmentDetailSR from '../../assessment/components/AssessmentDetailSR'
import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'

export default {
  name: 'entity-result',
  props: ['uuid', 'entityType', 'entityUuid'],
  components: {
    CourseHeaderSR,
    TOCSR,
    AssessmentDetailSR,
    RichHtmlLaunchAssessment
  },
  data: () => {
    return {
      isEntityDetailLoaded: false,
      isNextEntityDetailLoaded: false,
      isEntityActivityLoaded: false
    }
  },

  mounted () {
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail',
      'loadEntityActivity',
      'loadNextEntityDetail',
      'stopActivity'
    ]),

    loadCourse () {
      var entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      var nextEntityDetailInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      var entityActityInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.loadNextEntityDetail(nextEntityDetailInfo).then(res => {
        if (res) {
          this.isNextEntityDetailLoaded = true
          if (res.title === 'CONVERSATION_SUBMITTED') {
            return this.$router.push({ name: 'connection', params: {careerIdeaId: res.uuid} })
          }
        }
      })
      this.loadEntityDetail(entityDetailInfo).then(res => {
        if (res && res.type === 'ASSESSMENT') {
          this.isEntityDetailLoaded = true
          var stopActivity = {
            'userId': localStorage.getItem('userid'),
            'entityUuid': this.entityUuid,
            'rating': '0'
          }
          this.stopActivity(stopActivity)
        }
      })
      this.loadCourseDetail(this.uuid)
      this.loadEntityActivity(entityActityInfo).then(res => {
        if (res) {
          this.isEntityActivityLoaded = true
        }
      })
    },
    msToTime (s) {
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      var hrs = (s - mins) / 60
      return hrs + ' hrs ' + mins + ' mins ' + secs + ' seconds'
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'entity': state => state.course.entity,
      'nextEntity': state => state.course.nextEntity,
      'entityActivity': state => state.course.entityActivity
    })
  },
  watch: {
    entityUuid (newId) {
      if (newId) {
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>
.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description{
  padding-top:20px;
  padding-left:20px;
  padding-right:20px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.header-view {
  background: #ffeced!important;
}
.entity-nav, .header-view {
	min-height:60px;
	display: flex;
    align-items: center;
}
.entity-nav, .learning {
	background: #f8f9fa;
}
.pull-left{
  float:left;
}

.entity-title {
	margin-bottom: 0;
    font-size: 20px;
    margin-top: 2px;
    max-width: calc(100% - 57px);
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: robotoSlab_Light;
    min-height: auto;
    background: none;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
	-webkit-box-orient: vertical;
	position:relative;
	max-height:49px;
	padding-right:16px;
}
.entity-content-section {
	padding-right: 31px;
}

img {
	width:28px;
	height:26px;
}

.icon-asset {
    margin-right: 8px;
}

.description {
	margin-bottom: 5px;
}
.time_taken {
	margin-bottom: 20px;
    float: left;
}

.header-view.gradeA, .header-view.gradeB, .header-view.gradeC, .header-view.gradeD, .header-view.gradeE, .header-view.noGrade {
	width: 100%;
    float: left;
    height: 62px;
    position: absolute;
    left: 0px;
    opacity: 0.2;
    top: 0;
}
.icon {
	color: #b8652a;
    margin-right: 10px;
	float:left;
}

.gradeA::after {
	background:#c7e1c9
}

.gradeB::after {
	background:#e5e4cc;
}

.gradeC::after {
	background:#f6eed5;
}

.gradeD::after {
	background:#fae1ce;
}

.gradeE::after {
	background:#e8cecc;
}

.noGrade::after {
	background:#e0e1e2;
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/EntityResultSR.vue